/**
 * The single source of truth for The Scrapbook categories.
 *
 * A post stores its category as a plain string in its own row — it does not
 * point at a shared list. So renaming a category does NOT rename it on the posts
 * already filed under the old name. Rather than rewrite live data we keep the
 * old value in the database and translate it on read, the same way the Bulletin
 * does (see ../Bulletin/categories.js).
 *
 * Keep KEYS in sync with VALID_CATEGORIES in the backend's
 * flask_app/api/scrapbook/_shared.py. What the server does with a name it does
 * not recognise depends on which way it is going: on READ it falls back to
 * Memories, because a row written long ago still has to draw. On an EDIT it
 * REFUSES with a 400 (2026-09-20) — quietly refiling a post the member had
 * already put under Adventures is a worse answer than saying no.
 *
 * Agreed at the 2026-07-09 meeting ("possibly reunion, adventure, memories,
 * something intriguing") and confirmed by Sam on 2026-09-09.
 */
export const CATEGORIES = [
  { key: "adventures", label: "Adventures" },
  { key: "memories", label: "Memories" },
  { key: "life_updates", label: "Life updates" },
];

// Sam replaced the first four with these three on 2026-09-16. Posts already filed
// under a retired name keep their stored value — nothing in the database is
// rewritten — and simply read as Memories, here and on the server
// (category_as_read in flask_app/api/scrapbook/_shared.py).
export const RETIRED_CATEGORIES = { reunions: "memories", "something-intriguing": "memories" };

export const DEFAULT_CATEGORY = "memories";

export function categoryLabel(key) {
  const asked = RETIRED_CATEGORIES[key] || key;
  const found = CATEGORIES.find((c) => c.key === asked);
  return found ? found.label : "Memories";
}
